import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('language') || 'de');

  const setLang = useCallback((newLang) => {
    localStorage.setItem('language', newLang);
    setLangState(newLang);
  }, []);

  const t = useCallback((key, vars = {}) => {
    const str = translations[lang]?.[key] ?? translations['de']?.[key] ?? key;
    return Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), str);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
